import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CPagination } from "@coreui/react";
import numbro from "numbro";

const CardsList = () => {
  const metrics = useSelector((state) => state.prospectsCustomers.metrics);
  const [searchValue, setSearchValue] = useState("");

  const filteredMetrics = metrics.map((metric) => {
    const data = (metric.data || []).filter(({ name, info }) => {
      if (!searchValue) return true;
      const query = searchValue.toLowerCase();
      return (
        name.toLowerCase().includes(query) ||
        (info || "").toLowerCase().includes(query)
      );
    });

    return { ...metric, data };
  });

  return (
    <>
      <div className="pac-search">
        <div className="form-inline pl-0 c-datatable-filter search">
          <input
            className="form-control"
            type="text"
            placeholder="Search..."
            aria-label="table filter input"
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
          />
        </div>
      </div>
      <div className="pac-cards">
        {filteredMetrics.map(({ title, count, rawDataLink, data }, index) => {
          const [page, setPage] = useState(1);
          const totalPages = Math.ceil(data.length / 10) || 1;
          const paginatedData = data.slice((page - 1) * 10, page * 10);

          return (
            <div className="pac-card" key={index}>
              <div className="pac-card__header">
                <div className="pac-card__title">{title}</div>
                <div className="pac-card__count">
                  <a href={rawDataLink} target="_blank" rel="noopener noreferrer">
                    {numbro(count || 0).format({ thousandSeparated: true })}
                  </a>
                </div>
              </div>
              {paginatedData.map(({ name, info, link }, index) => (
                <div className="pac-card__el" key={index}>
                  <a className="pac-card__link" href={link} target="_blank" rel="noopener noreferrer">
                    {name}
                  </a>
                  {info && <span className="pac-card__info"> - {info}</span>}
                </div>
              ))}
              <div className="pac-card__pagination">
                <CPagination
                  style={{ display: totalPages > 1 ? "inline" : "none" }}
                  pages={totalPages}
                  limit={3}
                  activePage={page}
                  onActivePageChange={(nextPage) => setPage(nextPage)}
                />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default CardsList;
